/**
 * Windsurf config writer
 *
 * Skill: ~/.agents/skills/sailfish-autofix/ (cross-client) + ~/.windsurf/skills/
 * MCP: ~/.windsurf/mcp.json mcpServers.sailfishAutofix
 */

import { homedir } from "os";
import { join } from "path";
import type { AgentConfigWriter } from "./base.js";
import { copySkillTo, removeSkillFrom, installCrossClientSkill, removeCrossClientSkill, buildMcpEntry, mutateJsonFile } from "./base.js";
import { MCP_SERVER_NAME } from "../constants.js";

const WINDSURF_SKILLS_DIR = join(homedir(), ".windsurf", "skills");
const WINDSURF_MCP_CONFIG = join(homedir(), ".windsurf", "mcp.json");

export const windsurf: AgentConfigWriter = {
  id: "windsurf",
  name: "Windsurf",

  installSkill(global: boolean) {
    installCrossClientSkill(global);
    copySkillTo(WINDSURF_SKILLS_DIR);
  },

  installMcp() {
    mutateJsonFile(WINDSURF_MCP_CONFIG, (config) => {
      if (!config.mcpServers) config.mcpServers = {};
      config.mcpServers[MCP_SERVER_NAME] = buildMcpEntry();
      return config;
    });
  },

  uninstallSkill() {
    removeCrossClientSkill(true);
    removeSkillFrom(WINDSURF_SKILLS_DIR);
  },

  uninstallMcp() {
    mutateJsonFile(WINDSURF_MCP_CONFIG, (config) => {
      if (config.mcpServers?.[MCP_SERVER_NAME]) {
        delete config.mcpServers[MCP_SERVER_NAME];
      }
      return config;
    }, false);
  },
};
